export function handleScrollToTopWhenInCall() {
  window.scrollTo({ top: 0, behavior: 'instant' })
}
